import { format } from 'date-fns';

export const getMonthName = (monthNumber: number) => {
  const date = new Date(0, monthNumber - 1);
  const monthName = format(date, 'MMMM');
  return monthName;
};
